import React, { useState } from 'react';

import I18n from '../../../../../../utils/I18n';
import { logError } from '../../../../../../utils/sentry';

import styles from './PrivateLocationMap.scss';

interface PrivateLocation {
  id: string;
  address: string;
  mapUrl?: string | null;
}

interface PrivateLocationMapProps {
  privateLocation: PrivateLocation;
}

function PrivateLocationMap({ privateLocation }: PrivateLocationMapProps) {
  const { mapUrl, address } = privateLocation;
  const [failed, setFailed] = useState(false);

  if (!mapUrl || failed) {
    return <div className={styles.map} />;
  }

  return (
    <div className={styles.map}>
      <img
        src={mapUrl}
        alt={I18n.t('strava.settings.privacy.hide_address.map_alt', { address })}
        className={styles['map-image']}
        width={200}
        height={200}
        onError={() => {
          logError(new Error('Privacy zone map image failed to load'), { mapUrl });
          setFailed(true);
        }}
      />
    </div>
  );
}

export default PrivateLocationMap;
